export const AdditionalDepositButtonType = {
    None: 'DEFAULT',
    Floating: 'FLOATING_BUTTON',
    HeaderBar: 'HEADER_BUTTON',
} as const;
export type AdditionalDepositButtonType = typeof AdditionalDepositButtonType[keyof typeof AdditionalDepositButtonType];

export const PE92ExperimentVariant = {
    A: 'A',
    B1: 'B1',
    B2: 'B2',
    C1: 'C1',
    C2: 'C2',
} as const;
export type PE92ExperimentVariant = typeof PE92ExperimentVariant[keyof typeof PE92ExperimentVariant];

export const PeerUrgencyExperimentVariant = {
    A: 'A',
    B: 'B',
    C: 'C',
    None: 'None',
} as const;

export type PeerUrgencyExperimentVariant = typeof PeerUrgencyExperimentVariant[keyof typeof PeerUrgencyExperimentVariant];

export const FloatingPlaceBetButtonType = {
    None: 'Default',
    ThreeBetsInSevenDays: '3_bets_in_7_days',
    NoBets: 'No_bets',
} as const;
export type FloatingPlaceBetButtonType = typeof FloatingPlaceBetButtonType[keyof typeof FloatingPlaceBetButtonType];

export const PE131DescriptiveOddNameVariant = {
    None: 'Default',
    DisplayDescription: 'Description',
    ControlGroup: 'Control',
} as const;
export type PE131DescriptiveOddNameVariant = typeof PE131DescriptiveOddNameVariant[keyof typeof PE131DescriptiveOddNameVariant];

export const PE189PotentialWinLowBalanceVariant = {
    Control: 'Control',
    InButton: 'InButton',
    NewRow: 'NewRow',
} as const;
export type PE189PotentialWinLowBalanceVariant = typeof PE189PotentialWinLowBalanceVariant[keyof typeof PE189PotentialWinLowBalanceVariant];

type ExperimentSurveyType = {
  None: string,
  A: string, // A should always be the control group
  B: string,
  C: string,
  D: string,
};

export type ExperimentSurveyFlag = ExperimentSurveyType[keyof ExperimentSurveyType];
export const HomepageSurveyExperimentVariant = {
    None: 'None',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
} as const;
export type HomepageSurveyExperimentVariant = typeof HomepageSurveyExperimentVariant[keyof typeof HomepageSurveyExperimentVariant];

export const InspirationalCopyExperimentVariant = {
    None: 'None',
    A: 'A',
    B: 'B',
    C: 'C',
} as const;

export type InspirationalCopyExperimentVariant = typeof InspirationalCopyExperimentVariant[keyof typeof InspirationalCopyExperimentVariant];
